module.exports = __webpack_public_path__ + "67bf969b127246632ec89ede2f8819c3.png";